module.exports = "<audio #theAudioPlayer controls controlsList=\"nodownload\">\r\n  <source [src]=\"src\">\r\n</audio>\r\n"